import React, { useState } from 'react';

import { useSelector } from 'react-redux';
import Select, { components as selectComponents } from 'react-select';

import { selectStyles } from './selectStyles';
import { MultipleValuesContainer as MultiValue } from './MultiValueComponent';

import './styles/AutoSuggestSelect.scss';

export const AutoSuggestSelect = (props) => {
  const [selectClassName, setSelectClassName] = useState('');

  const themeColors = useSelector((state) => state.theme.themeValuesObject);
  const customStyles = selectStyles({ themeColors });

  const { inputClassName, components, ...otherProps } = props;

  const Input = (props) => <selectComponents.Input {...props} maxLength={50} />;

  return (
    <Select
      {...otherProps}
      isClearable={false}
      styles={customStyles}
      hideSelectedOptions={false}
      onBlur={() => setSelectClassName('')}
      classNamePrefix="generic-select-prefix"
      onFocus={() => setSelectClassName('select-focus-border-admin')}
      className={`custom-scroller generic-select ${
        inputClassName || ''
      } ${selectClassName}`}
      components={
        components
          ? { MultiValue, Input, MultiValueRemove: () => null, ...components }
          : { Input, MultiValue }
      }
    />
  );
};
